import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { Paper } from '@mui/material';
import styles from './box-layout.styles';
import Tooltip from './BinTooltip';
import LockIcon from '@mui/icons-material/Lock';
import classNames from 'classnames';
import BOX_TYPE from '../enum/box_type';
import { withTranslation } from 'react-i18next';
import {
    getColumnIdFromBinId as resolveColumnIdFromBinId,
    isRestrictedByColumnMapping as isColumnRestrictedByMapping,
    isBinRestrictedForUser,
    getColumnRestrictionHighlightStyle,
    shouldShowRestrictionLock,
} from './columnRestriction';

let nums2 = Array.from(Array(4).keys());
let nums4 = Array.from(Array(2).keys());
let BinIds = [];
let deactivatedBin = [];
let IsSaved;

export class CoolLayout extends Component {
    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                if (item) {
                    deactivatedBin.push(item);
                    let node = document.getElementById(item);
                    if (node !== null && node !== undefined) {
                        let x = node.parentNode.classList && node.parentNode.classList[2];
                        node.parentNode.classList.remove(x);
                        let items = document.getElementById(item);
                        if (items && items.style) {
                            items.style.background = '#f87171';
                            items.style.color = '#fff';
                            items.style.cursor = 'pointer';
                        }
                    }
                }
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                if (item) {
                    var items = document.getElementById(item);
                    if (items && items.style) {
                        items.style.background = '#f8fafc';
                        items.style.color = '#000';
                        items.style.cursor = 'pointer';
                        items.style.pointerEvents = 'all';
                    }
                }
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        if (this.props && this.props.BinStatus.length > 0) {
            this.props.BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    getColumnIdFromBinId = (binId) => resolveColumnIdFromBinId(binId);

    isRestrictedByColumnMapping = (binId) =>
        isColumnRestrictedByMapping(
            binId,
            this.props.columnMappings,
            this.props.userGroupType
        );

    isRestricted = (groupTypeId, binId) =>
        isBinRestrictedForUser({
            binId,
            userGroupType: this.props.userGroupType,
            columnMappings: this.props.columnMappings,
            occupiedGroupTypeId: groupTypeId,
        });

    getBinStyle = (binId) =>
        getColumnRestrictionHighlightStyle(
            binId,
            this.props.columnMappings,
            this.props.userGroupType
        );

    // Added by : Manav Pandya
    openbin = (binId, status, pm_id) => {
        // Check if bin is restricted by column mapping - don't allow opening if restricted
        if (this.isRestrictedByColumnMapping(binId)) {
            console.log('[Cool] openbin blocked - bin is restricted by column mapping:', binId);
            return; // Don't allow opening if restricted by column mapping
        }
        
        // Also check combined restriction (group type + column mapping)
        if (this.isRestricted(null, binId)) {
            console.log('[Cool] openbin blocked - bin is restricted (combined check):', binId);
            return;
        }
        
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                let items = document.getElementById(binId);
                items.style.background = '#f87171'; // deavtivated
                items.style.color = '#ffffff'
            }
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            // Handle deactivated bins without status - allow activation
            if (this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId, this.props.box_position);
                this.props.getPrescriptionDetails(binId, pm_id);
                let items = document.getElementById(binId);
                if (items) {
                    items.style.background = '#f87171'; // deavtivated
                    items.style.color = '#ffffff'
                }
            } else {
                BinIds.map((item) => {
                    this.checkIsSaved(item);
                    if (item !== binId && IsSaved === false) {
                        var items = document.getElementById(item);
                        items.style.background = '#f8fafc';
                    }
                    return true
                })
                BinIds = [];
                BinIds.push(binId);
                if (BinIds.length > 0) {
                    this.props.Selectedbin(binId, this.props.box_position, true);
                    var items = document.getElementById(binId);
                    items.style.background = '#fbbf24';
                }
            }
        }
    }

    getColumns = (currentIndex, currentColumnCount, previousColumnCount, side) => {
        // getColumns(1, 2, 0, 'left') should return columns
        let columns = [];
        if (side === 'L') {
            for (let i = (previousColumnCount + currentColumnCount); i > previousColumnCount; i--) {
                columns.push(String.fromCharCode(65 + (i - 1)) + String.fromCharCode(65 + (i - 1)))
            }
        } else {
            for (let i = previousColumnCount; i < (previousColumnCount + currentColumnCount); i++) {
                columns.push(String.fromCharCode(65 + (i - 1)))
            }
        }
        return columns;
    }

    // | -3 | -2 | -1 |
    // | 36 |  8 | 60 |
    // | 3  |  2 |  5 |

    // 3 - current Index
    // 7 - Prev Index

    getCurrentAndPreviousPosition = (side) => {
        const { expansion, ExpansionsCounts, boxTypeId } = this.props;
        let response = {};
        response.currentCount = expansion.bin_column_count;
        if (side === 'L') {
            let _expansionsCount = ExpansionsCounts && ExpansionsCounts.leftExpansions;
            if (expansion.box_position === -1 || expansion.box_position === '-1') {
                response.previousCount = 0;
            } else {
                response.previousCount = this.excludeCurrentExpansion(expansion, _expansionsCount);
            }
        } else {
            let _expansionsCount = ExpansionsCounts.rightExpansions;
            if (expansion.box_position === 1 || expansion.box_position === '1') {
                if ([BOX_TYPE.Locker, BOX_TYPE.M41].includes(boxTypeId)) {
                    response.previousCount = 6;
                } else {
                    response.previousCount = 4;
                }
            } else {
                if ([BOX_TYPE.Locker, BOX_TYPE.M41].includes(boxTypeId)) {
                    response.previousCount = this.excludeCurrentExpansion(expansion, _expansionsCount) + 6;
                } else {
                    response.previousCount = this.excludeCurrentExpansion(expansion, _expansionsCount) + 4;
                }
            }
        }
        return response;
    }

    excludeCurrentExpansion = (expansion, expansionArray) => {
        let currentUnitIndex = null;
        for (let index = 0; index < expansionArray.length; index++) {
            if (expansionArray[index].expansionId === expansion.id) {
                currentUnitIndex = index;
                break;
            }
        }
        if (currentUnitIndex === null || currentUnitIndex <= 0) {
            return 0;
        }
        return expansionArray
            .slice(0, currentUnitIndex)
            .reduce((sum, item) => sum + Number(item.bin_column_count || 0), 0);
    }

    renderBinLabel = (binId, label, occupiedGroupTypeId = null) => {
        const parts = String(label).trim().split(/\s+/);
        const letter = parts[0] || '';
        const number = parts.slice(1).join(' ') || '';
        const { classes } = this.props;
        const showLock = shouldShowRestrictionLock({
            binId,
            userGroupType: this.props.userGroupType,
            columnMappings: this.props.columnMappings,
            occupiedGroupTypeId,
        });
        return (
            <span className={classes.coolBinLabelWrap}>
                {showLock ? <LockIcon className={classes.coolBinLockIcon} fontSize="inherit" /> : null}
                <span className={classes.coolBinLabel}>
                    <span className={classes.coolBinLabelLetter}>{letter}</span>
                    <span className={classes.coolBinLabelNumber}>{number}</span>
                </span>
            </span>
        );
    };

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }

        const { classes, BinStatus, box_position, t, deactivatedBins, isViewPermissionAllowed, PatientID, ADAData } = this.props;
        let elem4 = [];
        let side = box_position < 0 ? 'L' : 'R'
        if (side === 'L') {
            let prevNextCount = this.getCurrentAndPreviousPosition(side);
            let previousExpansionCount = (prevNextCount && prevNextCount.previousCount) ? (prevNextCount.previousCount) : 0;
            elem4 = this.getColumns(box_position, prevNextCount && prevNextCount.currentCount, previousExpansionCount, side);
        } else {
            let prevNextCount = this.getCurrentAndPreviousPosition(side);
            let previousExpansionCount = (prevNextCount && prevNextCount.previousCount) ? (prevNextCount.previousCount) : 0;
            elem4 = this.getColumns(box_position, prevNextCount && prevNextCount.currentCount, previousExpansionCount, side);
        }
        return (
            <div
                className={classNames(classes.coolFridgeCabinet, classes.coolFridgeGrid8)}
                style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
            >
                {nums2.flatMap(n1 => {
                     let doorInx = n1 + 1;
                     const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                         return (
                             item &&
                             item.patient_id === PatientID &&
                             item.ada_compitible === true &&
                             ![2, 3].includes(doorInx)
                         );
                     });
                    return nums4.map(n => {
                                // if (elem4[n] === 'N' || elem4[n] === 'O') {
                                if (this.props && this.props.BinStatus && BinStatus.length > 0) {
                                    let BinKey = elem4[n] + (n1 + 1)
                                    for (var i = 0; i < BinStatus.length; i++) {
                                        let pm_id = BinStatus[i].id;
                                        let occupiedGroupTypeId = BinStatus[i].group_type_id;
                                        let isLockedBin = BinStatus[i].is_locked;
                                        if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                            if (deactivatedBins.includes(BinKey)) {
                                                return (
                                                    <Tooltip key={BinKey} title="DEACTIVATE">
                                                        <div
                                                            className={classes.coolBinCell8}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={(e) => {
                                                                const binId = elem4[n] + '' + (n1 + 1);
                                                                // Double-check restriction before opening
                                                                if (this.isRestricted(null, binId)) {
                                                                    console.log('[Cool] Click blocked - bin is restricted:', binId);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                this.openbin(binId, 'Stocked', pm_id);
                                                            }}
                                                            key={BinKey}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                                style={{
                                                                    // Apply visual styling for column-restricted bins
                                                                    ...(this.isRestrictedByColumnMapping(elem4[n] + '' + (n1 + 1)) ? { backgroundColor: '#FFE0B2', border: '2px solid #FF9800', color: '#422006' } : {}),
                                                                }}>
                                                                {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Stocked")}>
                                                        <div
                                                            className={`${isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool} ${classes.coolBinCell8}`}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={(e) => {
                                                                const binId = elem4[n] + '' + (n1 + 1);
                                                                // Double-check restriction before opening
                                                                if (this.isRestricted(null, binId)) {
                                                                    console.log('[Cool] Click blocked - bin is restricted:', binId);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                this.openbin(binId, 'Stocked', pm_id);
                                                            }}
                                                            key={BinKey}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(isLockedBin ? classes.gridPurpleBinCool : classes.gridOrangebackCool, classes.boxLayout)}
                                                                style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}>
                                                                {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                        else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                            if (deactivatedBins.includes(BinKey)) {
                                                return (
                                                    <Tooltip key={BinKey} title="DEACTIVATE">
                                                        <div
                                                            className={classes.coolBinCell8}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={(e) => {
                                                                const binId = elem4[n] + '' + (n1 + 1);
                                                                // Double-check restriction before opening
                                                                if (this.isRestricted(null, binId)) {
                                                                    console.log('[Cool] Click blocked - bin is restricted:', binId);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    return;
                                                                }
                                                                this.openbin(binId, 'Assigned', pm_id);
                                                            }}
                                                            key={BinKey}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                                style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}>
                                                                {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Assigned")}>
                                                        <div
                                                            className={`${isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool} ${classes.coolBinCell8}`}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={() => this.openbin((elem4[n] + '' + (n1 + 1)), 'Assigned', pm_id)}
                                                            key={BinKey}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(isLockedBin ? classes.gridPurpleBinCool : classes.gridBluebackCool, classes.boxLayout)}
                                                                style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}>
                                                                {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                        else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                            if (deactivatedBins.includes(BinKey)) {
                                                return (
                                                    <Tooltip key={BinKey} title="DEACTIVATE">
                                                        <div
                                                            className={classes.coolBinCell8}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={() => this.openbin(elem4[n] + '' + (n1 + 1), 'Hold', pm_id)}
                                                            key={BinKey}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                                style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}>
                                                                {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Hold")}>
                                                        <div
                                                            className={`${isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool} ${classes.coolBinCell8}`}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                            onClick={() => this.openbin((elem4[n] + '' + (n1 + 1)), 'Hold', pm_id)}
                                                            key={BinKey}>
                                                            <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(isLockedBin ? classes.gridPurpleBinCool : classes.gridSkybluebackCool, classes.boxLayout)}
                                                                style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}>
                                                                {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`, occupiedGroupTypeId)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                    }
                                    if (deactivatedBins.length > 0 && deactivatedBins.findIndex((D) => D === (elem4[n] + (n1 + 1))) > -1) {
                                        return (
                                            <Tooltip key={((elem4[n]) + ' ' + (n1 + 1))} title="DEACTIVATE" >
                                                <div
                                                    className={classes.coolBinCell8}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                    onClick={() => this.openbin(elem4[n] + '' + (n1 + 1))}
                                                    key={((elem4[n]) + ' ' + (n1 + 1))}>
                                                    <Paper
                                                        id={elem4[n] + '' + (n1 + 1)}
                                                        className={classNames(classes.gridRedbackCool, classes.boxLayout)}
                                                        style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}
                                                    >
                                                        {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`)}
                                                    </Paper>
                                                </div>
                                            </Tooltip>
                                        );
                                    }
                                    else {
                                            return (
                                                <Tooltip key={BinKey} title={t("Global.Prescriptions.Status.Available")}>
                                                    <div
                                                        className={`${isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool} ${classes.coolBinCell8}`}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                        onClick={() => this.openbin(elem4[n] + '' + (n1 + 1))}
                                                        key={elem4[n] + ' ' + (n1 + 1)}>
                                                        <Paper id={elem4[n] + '' + (n1 + 1)} className={classNames(classes.gridbackCool, classes.boxLayout)}
                                                            style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}>
                                                            {this.renderBinLabel(BinKey, `${elem4[n]} ${n1 + 1}`)}
                                                        </Paper>
                                                    </div>
                                                </Tooltip>
                                            );
                                        }
                                } else {
                                    return (
                                        <Tooltip key={((elem4[n]) + ' ' + (n1 + 1))} title={t("Global.Prescriptions.Status.Available")}>
                                            <div
                                                className={`${isdisabledDoor ? classes.disableCoolDoor : classes.kioskDoorCool} ${classes.coolBinCell8}`}
                                                            style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                                                onClick={() => this.openbin(elem4[n] + '' + (n1 + 1))}
                                                key={elem4[n] + ' ' + (n1 + 1)}>
                                                <Paper
                                                    id={elem4[n] + '' + (n1 + 1)}
                                                    className={classNames(classes.gridbackCool, classes.boxLayout)}
                                                    style={this.getBinStyle(elem4[n] + '' + (n1 + 1))}
                                                >
                                                    {this.renderBinLabel(elem4[n] + '' + (n1 + 1), `${elem4[n]} ${n1 + 1}`)}
                                                </Paper>
                                            </div>
                                        </Tooltip>
                                    );
                                }
                            });
                })}
            </div>
        );
    }
}

export default withStyles(styles)(withTranslation()(CoolLayout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Cool-layout.js